// Latest Code By Anuj Apr21,2025
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
    Box, Card, CardContent, Grid, Typography
} from "@mui/material"
import { memo, useState } from "react";
import ApartmentIcon from '@mui/icons-material/Apartment';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { PiHeadCircuitLight } from "react-icons/pi";
import { TimecardAccounting } from './TimecardAccounting';
import { PayrollAccounting } from './PayrollAccounting';
import { InvoiceAccounting } from './InvoiceAccounting';

const resources = [
    {
        id: 1,
        icon: <ApartmentIcon color="primary" />,
        text: "TimeCard",
        actionIcon: <ChevronRightIcon sx={{ color: '#6ebe44' }} />,
        route: "/admin/profile-criteria/work-area",
        headline: "Time Manager",
        url: "/roles"
    },
    {
        id: 2,
        icon: <EngineeringIcon sx={{ color: '#ffa500' }} />,
        text: "Payroll",
        actionIcon: <ChevronRightIcon sx={{ color: '#6ebe44' }} />,
        route: "/admin/profile-criteria/work-type",
        headline: "Pay Roll",
        url: "/payroll"
    },
    {
        id: 3,
        icon: <PiHeadCircuitLight color="#C7253E" size={24} />,
        text: "Invoice",
        actionIcon: <ChevronRightIcon sx={{ color: '#6ebe44' }} />,
        route: "/admin/profile-criteria/fetchSpecialtyRoleMappings",
        headline: "Invoice",
        url: "/invoice"
    },
];









const AdminAccounting = () => {
    const [selectedTab, setSelectedTab] = useState(resources[0]);

    const renderTab = () => {
        switch (selectedTab?.text) {
            case 'TimeCard':

                return <TimecardAccounting selectedTab={selectedTab} />;
            case 'Payroll':
                return <PayrollAccounting selectedTab={selectedTab} />;
            case 'Invoice':
                return <InvoiceAccounting selectedTab={selectedTab} />;
            default:
                return <>{selectedTab?.text}</>;
        }
    }
    return (
        <Grid container>
            <Grid item xs={12} mb={2} mt={2}>
                <Card sx={{ padding: "20px", borderRadius: "8px" }}>
                    <CardContent>
                        <Typography variant="h2" component="div" fontWeight="bold">
                            Resources
                        </Typography>
                    </CardContent>
                    <Grid container spacing={1}>
                        {resources.map((item) => (
                            <Grid key={item.id} item lg={3} sm={6} xs={12}>
                                <CardContent>
                                    <Box
                                        sx={{
                                            // width: 250,
                                            // height: 40,
                                            borderRadius: "8px",
                                            padding: "10px",
                                            cursor: "pointer",
                                            backgroundColor:
                                                selectedTab.id === item.id ? "#e0f7d4" : "#f5f5f5",
                                            transition:
                                                "background-color 0.3s ease-in-out, transform 0.2s ease-in-out",
                                            '&:hover': {
                                                backgroundColor: "#e0f7d4",
                                                transform: "scale(1.05)",
                                            },
                                        }}
                                        onClick={() => { setSelectedTab(item); }}
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"space-between"}
                                    >
                                        {item.icon}
                                        <Typography
                                            variant="body1"
                                            sx={{ marginLeft: '10px', flexGrow: 1 }}
                                        >
                                            {item.text}
                                        </Typography>
                                        {item.actionIcon}
                                    </Box>
                                </CardContent>
                            </Grid>
                        ))}
                    </Grid>
                </Card>
            </Grid>
            <Grid item lg={12} mb={2} >
                <Card sx={{ padding: "20px", borderRadius: "8px", marginTop: "20px" }}>
                    {renderTab()}
                </Card>
            </Grid>

        </Grid>
    );
};

export default memo(AdminAccounting);





